import { GridRowAction } from '../types/grid';
import { GridRef } from '../types/refs';

export interface RowActionsOptions {
  /** Drops AG's default context-menu entries (copy/paste/charts/export). */
  suppressDefaults?: boolean;
}

/** Registers consumer-defined entries for the grid's row context menu. */
export function rowActions<TRow extends object>(
  ref: GridRef<TRow>,
  actions: GridRowAction<TRow>[],
  options?: RowActionsOptions
): void {
  ref.setRowActions({ actions, suppressDefaults: options?.suppressDefaults });
}
